<template>
    
    <div class="banner">

        <picture>
            
            <source media="(min-width: 992px)" width="2940" height="700" type="image/jpeg" srcset="/assets/new-eng-landing/toibanner/toietmoi.jpg">
            <source media="(min-width: 992px)" width="2940" height="700" type="image/webp" srcset="/assets/new-eng-landing/toibanner/toietmoi.webp">

            <!-- 
            <source media="(min-width: 768px) and (max-width: 991px)" width="1684" height="1120" type="image/jpeg" srcset="~/assets/landing/fastship/black-friday/instock_992.jpg">
            <source media="(min-width: 768px) and (max-width: 991px)" width="1684" height="1120" type="image/webp" srcset="~/assets/landing/fastship/black-friday/instock_992.webp"> -->


            <!-- <source media="(max-width: 767px)" width="686" height="1020" type="image/jpeg" srcset="~/assets/landing/fastship/black-friday/instock_mob.png"> -->
            <source media="(max-width: 992px)" width="687" height="960" type="image/webp" srcset="/assets/new-eng-landing/toibanner/toietmoi_mob.webp">
            <source media="(max-width: 992px)" width="687" height="960" type="image/jpg" srcset="/assets/new-eng-landing/toibanner/toietmoi_mob.jpg">


            <img class="radious_eight" loading="lazy" width="2940" height="700" alt="Create Your Own Ring" src="/assets/new-eng-landing/toibanner/toietmoi.jpg">

        </picture>

        <div class="ship_upper">

            <h4 class="font-active mb-2">Toi Et Moi <br> Engagement Rings</h4>

            <p class="mb-3">Celebrate your love with our vast collection of <br>toi-et-moi rings- two stones, one unforgettable <br>bond. 
            </p>

            <div class="ship_flex">

                <NuxtLink class="anker radious_four" :to="localePath({ name:'toi-et-moi-ring'})">SHOP TOI ET MOI RINGS</NuxtLink>

            </div>

        </div>

    </div>

</template>

<script setup>

    const localePath = useLocalePath();

</script>


<style scoped>
img {
    width: 100%;
}

.banner {
    position: relative;
}

.ship_upper {
    position: absolute;
    top: 50%;
    left: 75%;
    transform: translate(-40%, -50%);
    width: 50%;
    text-align: left;
}
.ship_upper h4 br {
    display: none;
}
.ship_upper h4 {
    font-size: 32px;
    color: #212529;
}

.ship_upper p {
    padding: 10px 0;
    /* color: #353535; */
    color: #606060;
}

.anker {
    display: inline-block;
    font-size: 14px;
    /* color: #000; */
    color: #212529;
    /* border: 1px solid #000; */
    border: 1px solid #212529;
    text-transform: uppercase;
    font-weight: 600;
    min-width: 300px;
    text-align: center;
    padding: 12px 20px;
    letter-spacing: 1.5px;
}


@media (max-width: 1300px) {

    .ship_upper h4 {
        font-size: 24px;
    }

    .ship_upper p {
        font-size: 14px;
    }

    .anker {
        font-size: 14px;
        padding: 12px 20px;
    }
}

@media(max-width: 991px) {
    .ship_upper {
        position: absolute;
        top: 74%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 45%;
        text-align: center;
    }

    .ship_upper p br {
        display: none;
    }

    .ship_flex {
        display: flex;
        flex-direction: column;
        gap: 0;
    }

    .anker {
        margin-bottom: 12px;
        text-align: center;
    }
}

@media (max-width: 767px) {
    .ship_upper {
        width: 90%;
        text-align: center;
    }
    .ship_upper h4 br {
        display: block;
    }
    .ship_upper h4 {
        font-size: 24px;
    }

    .ship_upper p {
        font-size: 14px;
    }

    .ship_flex {
        width: 100%;
        align-items: center;
    }

    .anker {
        width: 80%;
        text-align: center;
        font-size: 14px;
        padding: 12px 20px;
    }

}
</style>
